import { useOperator, useSorting } from "@/hooks";

/**
 * The booking table's sort, remembered between sessions.
 *
 * A wrapper rather than a `useSorting({ name })` at each call site because the bookings page holds two
 * instances — `BookingsTableV2` for the header arrows and `useGetBookingsParams` for the query — and
 * they have to agree on the key or they would restore different sorts from the same storage.
 *
 * Operator-scoped: switching operator should not inherit the previous one's ordering.
 */
export const useBookingSorting = () => {
  const { id: operatorId } = useOperator();

  return useSorting({ name: `${operatorId}:bookings-sort` });
};
